import { memberRegistrationUrl } from '../../../../features/url/baseUrl';
import { RedirectUriAfterRegistration } from '../../../../types/RedirectUriAfterRegistration';
import { BlockInnerTextButton } from '../../../Block/BlockInnerTextButton';
import {
  FormBlockLogin,
  type FormLoginProps,
} from '../../../Form/FormBlock/FormBlockLogin';
import { InnerMargin } from '../../../Layout/InnerLayout/InnerMargin';
import { Title } from '../../../Title';

import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC } from 'react';

export type LoginContentsProps = FormLoginProps & {
  appEnv: AppEnv;
  disableSubmitButton?: boolean;
  errorMessage?: string;
  redirectUriAfterRegistration?: RedirectUriAfterRegistration;
};

// eslint-disable-next-line max-lines-per-function
export const LoginContents: FC<LoginContentsProps> = ({
  appEnv,
  disableSubmitButton,
  invalidParams,
  errorMessage,
  eventHandlers,
  redirectUriAfterRegistration,
}) => (
  <>
    <InnerMargin align="default">
      <FormBlockLogin
        invalidParams={invalidParams}
        disableSubmitButton={disableSubmitButton}
        errorMessage={errorMessage}
        eventHandlers={eventHandlers}
      />
    </InnerMargin>
    <InnerMargin align="default">
      <Title type="h2" title="会員登録がまだの方" />
      <BlockInnerTextButton
        button="primary"
        buttonText="新規会員登録（無料）"
        link={
          redirectUriAfterRegistration
            ? `${memberRegistrationUrl(
                appEnv,
              )}?redirect_uri=${redirectUriAfterRegistration}`
            : memberRegistrationUrl(appEnv)
        }
      >
        ナース専科には看護師・看護学生のスキルアップに役立つ情報が満載！
      </BlockInnerTextButton>
    </InnerMargin>
  </>
);
